import { Component, OnInit } from '@angular/core';
import { UserService } from "../services/user/user.service";
import {Router,NavigationExtras} from "@angular/router"
import { AppComponent } from "../app.component";
@Component({
  selector: 'app-dashmenu',
  templateUrl: './dashmenu.component.html',
  styleUrls: ['./dashmenu.component.css']
})
export class DashmenuComponent implements OnInit {

  constructor(private userService:UserService,private router:Router,private appComponent:AppComponent) { }
  pageName:any;
  ngOnInit(): void {

    this.pageName = this.router.url.replace('/','');

  }

  logout() {


    this.userService.logOut().subscribe(res => {
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      localStorage.removeItem('typeCompte')
      this.appComponent.isLoged = false;
      this.router.navigate(['/'])
    },
      err => {
        console.log(err);
      }
    )

  }

  tabNavigation(page)
  {

    let element = document.getElementById(page.replace('/',''));
    element.className = 'list-group-item active';
    // switch (page) {
    //   case '/b2b':
    //     let element = document.getElementById('b2b');
    //     element.className = 'list-group-item active';
    //     break;
    //   case '/infos':
    //     break;
    //   case '/balances':
    //     break;
    //   case '/commandes':
    //     break;
    //   case '/factures':
    //     break;
    //   case '/wallet':
    //     break;
    //   case '/adress':
    //     break;
    //   default:
    //     break;
    // }
  }



}
